import { render, staticRenderFns } from "./createFamily.vue?vue&type=template&id=40300ba5&scoped=true"
import script from "./createFamily.vue?vue&type=script&lang=js"
export * from "./createFamily.vue?vue&type=script&lang=js"
import style0 from "./createFamily.vue?vue&type=style&index=0&id=40300ba5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40300ba5",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Supplies/Existence/createFamily.vue
// module id = 2124
// module chunks = 31